// @flow
import Newsletter from 'components/newsletter/Newsletter';
import { connect } from 'react-redux';

import { fetchArticles } from 'actions/newsletterActions';
import { fetchArticlesCategories } from 'actions/newsletterActions';
import { fetchGenericSidebar } from 'actions/sidebarActions';
import type { DispatchType, StateType } from 'types/Actions';
import type { DispatchProps, StateProps } from 'components/newsletter/Newsletter';

export default connect(
  (state: StateType): StateProps => ({
    status: state.newsletterState.status,
    news: state.newsletterState.articles,
    sidebar: state.sidebarState,
    categoriesArticle: state.newsletterState.categoriesArticle,
    ligue: state.settingsState.ligue
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchArticles: (page: number, per_page: number) => dispatch(fetchArticles(page, per_page)),
    fetchArticlesCategories: (page: number, per_page: number) => dispatch(fetchArticlesCategories(page, per_page)),
    fetchGenericSidebar: () => dispatch(fetchGenericSidebar()),
  })
)(Newsletter);
